import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 默认打开第一个
      activeName: "1",
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        auditUser: null, // 核验人员
        auditRemark: null // 核验意见
      },
      // 查询表单基础数据
      formSearchList: [
        // {
        //   type: "input",
        //   label: "核验人员：",
        //   value: "auditUser",
        //   placeholder: "请输入",
        //   clearable: true
        // },
        {
          type: "input",
          label: "核验意见：",
          value: "auditRemark",
          placeholder: "请输入",
          clearable: true
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "核验人员",
          slotName: "auditUser"
        },
        {
          label: "核验级别",
          prop: "stepName"
        },
        {
          label: "核验意见",
          prop: "auditRemark"
        },
        {
          label: "核验时间",
          prop: "auditDate"
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0
    };
  },

  // 接收父组件传递的数据
  props: {
    // 页面类型
    recordNumber: {
      type: String
    }
  },

  // 模板编译完成
  mounted() {},

  // 自定义方法
  methods: {
    /**
     * 切换tab
     * @author shuhua
     */
    handleClick() {
      // 分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 清空数据
      this.tableData = [];
      // 条数
      this.total = 0;
      // tab为核验记录
      if (this.activeName === "1") {
        // 查询表单绑定值
        this.form = {
          auditUser: null, // 核验人员
          auditRemark: null // 核验意见
        };

        // 查询表单基础数据
        this.formSearchList = [
          // {
          //   type: "input",
          //   label: "核验人员：",
          //   value: "auditUser",
          //   placeholder: "请输入"
          // },
          {
            type: "input",
            label: "核验意见：",
            value: "auditRemark",
            placeholder: "请输入"
          }
        ];
        // 表格基础数据
        this.tableColumns = [
          {
            label: "核验人员",
            slotName: "auditUser"
          },
          {
            label: "核验级别",
            prop: "stepName"
          },
          {
            label: "核验意见",
            prop: "auditRemark"
          },
          {
            label: "核验时间",
            prop: "auditDate"
          }
        ];
        // 获取核验记录一览
        this.fun_GetList();
      } else {
        // 查询表单绑定值
        this.form = {
          auditUser: null, // 核验人员
          stepName: null // 核验级别
        };
        // 查询表单基础数据
        this.formSearchList = [
          // {
          //   type: "input",
          //   label: "核验人员：",
          //   value: "auditUser",
          //   placeholder: "请输入"
          // },
          {
            type: "input",
            label: "核验级别：",
            value: "stepName",
            placeholder: "请输入"
          }
        ];
        // 表格基础数据
        this.tableColumns = [
          {
            label: "核验人员",
            slotName: "auditUser"
          },
          // {
          //   label: "监管单位",
          //   prop: "regionName"
          // },
          {
            label: "核验级别",
            prop: "stepName"
          },
          {
            label: "核验节点名称",
            prop: "processName"
          }
        ];
        // 获取核验节点一览
        this.fun_GetAuditNodeList();
      }
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 数据编号不为空时
      if (this.recordNumber != "" && this.recordNumber != null) {
        // 发起请求
        fun_PostAction("/auditLog/auditHistoryRecordNo", {
          ...this.form,
          ...this.reqPageData,
          businessRecordNo: this.recordNumber
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 操作成功
          if (result) {
            // 列表数据
            this.tableData = data.records;
            // 总条数
            this.total = data.total;
          } else {
            // 错误消息提示
            this.$message.error(msg);
          }
        });
      }
    },
    /**
     * 当前核验节点一览
     * @author shuhua
     */
    fun_GetAuditNodeList() {
      // 数据编号不为空时
      if (this.recordNumber != "" && this.recordNumber != null) {
        // 发起请求
        fun_PostAction("/auditProcess/getBusinessProcessList", {
          ...this.form,
          ...this.reqPageData,
          recordNo: this.recordNumber
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 操作成功
          if (result) {
            // 列表数据
            this.tableData = data.records;
            // 总条数
            this.total = data.total;
          } else {
            // 错误消息提示
            this.$message.error(msg);
          }
        });
      }
    },
    /**
     * 查询事件
     * @author shuhua
     */
    fun_Search() {
      // 分页参数
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 当前tab为核验记录
      if (this.activeName === "1") {
        // 获取一览表格数据
        this.fun_GetList();
      } else {
        // 获取当前核验节点一览
        this.fun_GetAuditNodeList();
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 当前tab为核验记录
      if (this.activeName === "1") {
        // 获取一览表格数据
        this.fun_GetList();
      } else {
        // 获取当前核验节点一览
        this.fun_GetAuditNodeList();
      }
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 当前tab为核验记录
      if (this.activeName === "1") {
        // 获取一览表格数据
        this.fun_GetList();
      } else {
        // 获取当前核验节点一览
        this.fun_GetAuditNodeList();
      }
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 当前tab为核验记录
      if (this.activeName === "1") {
        // 获取一览表格数据
        this.fun_GetList();
      } else {
        // 获取当前核验节点一览
        this.fun_GetAuditNodeList();
      }
    }
  }
};
